var scope_0 = require('/Users/aymenalashwal/PP/hooks-talk-react-kl/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3fc2914f0436acea67d03701a203023c.js').default;export default
        Object.assign({}, scope_0 )
    